import HTMLColumnsStrategy from '../HTMLColumnsStrategy'

export default function CostHTMLPreviewBaseColumnsStrategy() {}

CostHTMLPreviewBaseColumnsStrategy.prototype = new HTMLColumnsStrategy();

CostHTMLPreviewBaseColumnsStrategy.prototype.init = function( timeFormat, showSpentTime, showAverageRates )
{
    HTMLColumnsStrategy.prototype.init.call( this, timeFormat );
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addOverallHeaderCells = function( row )
{
    if( this.showSpentTime )
        this.addCell( row, this.message( "report.cost.overall_spent.csv" ), "overallSpent", 1, 3 );
    if( this.showAverageRates )
        this.addCell( row, this.message( "report.cost.average_rate.csv", [SystemSettings.currencySign] ), "averageRate", 1, 3 );
    this.addCell( row, this.message( "report.cost.overall_cost.csv", [SystemSettings.currencySign] ), "overallCost", 1, 3 );
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addOverallDataCells = function( row )
{
    if( this.showSpentTime )
        this.addTimeValueCell( row, "spentTimeDataCell" );
    if( this.showAverageRates )
        this.addMoneyValueCell( row );
    this.showSpentTime || this.showAverageRates ? this.addCostDataCell( row ) : this.addMoneyValueCell( row );
};

CostHTMLPreviewBaseColumnsStrategy.prototype.getOverallColumnsCount = function()
{
    var count = 1;
    if( this.showSpentTime ) count ++;
    if( this.showAverageRates ) count ++;
    return count;
};


CostHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function( row )
{
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function( row )
{
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function( row )
{
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function( row )
{
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.getDataColumnsCount = function()
{
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.areThereTwoRowsInHeader = function ()
{
    return false;
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addCostDataCell = function ( row )
{
    this.addMoneyValueCell( row, "darkMoneyValueCell");
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewBaseColumnsStrategy.js